"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Home = function Home(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M17.003 5.132c.345 0 .625.28.625.625V8.42a.234.234 0 01-.4.165L15.311 6.67a.625.625 0 01-.183-.442v-.47c0-.346.28-.625.625-.625h1.25zm0 13.75h-2.812a.625.625 0 01-.625-.625v-3.75a.625.625 0 00-.625-.625h-1.875a.625.625 0 00-.625.625v3.75c0 .345-.28.625-.625.625H7.003a.625.625 0 01-.625-.625v-5.63H5.131a.625.625 0 01-.442-1.067l6.873-6.877a.625.625 0 01.884 0l6.873 6.877a.625.625 0 01-.441 1.067h-1.25v5.63c0 .345-.28.625-.625.625z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Home);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Home, "Home", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Home.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Home.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9Ib21lLnRzeCJdLCJuYW1lcyI6WyJIb21lIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLElBQW9FLEdBQUcsU0FBdkVBLElBQXVFLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQzNFO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLENBQUMsRUFBQyxtYkFESjtBQUVFLElBQUEsSUFBSSxFQUFDO0FBRlAsSUFERixDQUQyRTtBQUFBLENBQTdFOztlQVNlLHVCQUFXRixJQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLEkiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEhvbWU6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xNy4wMDMgNS4xMzJjLjM0NSAwIC42MjUuMjguNjI1LjYyNVY4LjQyYS4yMzQuMjM0IDAgMDEtLjQuMTY1TDE1LjMxMSA2LjY3YS42MjUuNjI1IDAgMDEtLjE4My0uNDQydi0uNDdjMC0uMzQ2LjI4LS42MjUuNjI1LS42MjVoMS4yNXptMCAxMy43NWgtMi44MTJhLjYyNS42MjUgMCAwMS0uNjI1LS42MjV2LTMuNzVhLjYyNS42MjUgMCAwMC0uNjI1LS42MjVoLTEuODc1YS42MjUuNjI1IDAgMDAtLjYyNS42MjV2My43NWMwIC4zNDUtLjI4LjYyNS0uNjI1LjYyNUg3LjAwM2EuNjI1LjYyNSAwIDAxLS42MjUtLjYyNXYtNS42M0g1LjEzMWEuNjI1LjYyNSAwIDAxLS40NDItMS4wNjdsNi44NzMtNi44NzdhLjYyNS42MjUgMCAwMS44ODQgMGw2Ljg3MyA2Ljg3N2EuNjI1LjYyNSAwIDAxLS40NDEgMS4wNjdoLTEuMjV2NS42M2MwIC4zNDUtLjI4LjYyNS0uNjI1LjYyNXpcIlxuICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKEhvbWUpO1xuIl19